define([
    "./moveToAnotherUserModule",
    "./moveToAnotherUserModal"
], function () {
});